<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title>
				<button type="button" class="btn-flat-icon--dark" @click="open=false">
					<v-icon large flat>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="pt-0 event-page__modal-card-text">
				<div>
					<div v-if="event.pending_attendees.length > 0">
						<h4 class="text-xs-center error--text">Pending Attendees</h4>
						<v-list>
							<v-list-tile avatar v-for="attendee in event.pending_attendees" :key="attendee.uuid" @click="openGuestModal(attendee.uuid)">
								<v-list-tile-avatar>
									<img :src="attendee.avatar">
								</v-list-tile-avatar>
								<v-list-tile-content style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
									<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline">
										<v-tooltip top>
											<v-btn icon slot="activator" @click.stop="approveGuest(attendee.uuid)" class="ma-0">
												<v-icon color="success">fal fa-plus-circle</v-icon>
											</v-btn>
											<span>Approve</span>
										</v-tooltip>
										<v-tooltip top>
											<v-btn icon slot="activator" @click.stop="denyGuest(attendee.uuid)" class="ma-0">
												<v-icon color="error">fal fa-minus-circle</v-icon>
											</v-btn>
											<span>Deny</span>
										</v-tooltip>
									</div>
									<v-list-tile-title v-text="attendee.first_name + ' ' + attendee.last_name"></v-list-tile-title>
									<v-tooltip top v-if="userInAddon(attendee.pk)">
										<v-icon small slot="activator" class="ma-0 pa-0">fal fa-star</v-icon>
										<span>Attending {{event.addons[0].title}}</span>
									</v-tooltip>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
					</div>
					<p class="text-xs-center event-page__going error--text mb-1">Attendees</p>
					<p class="text-xs-center mb-1" style="font-size: 1.1em; font-weight: bold; font-family: 'Quantico'; color: #666">{{event.attendees.length}}&nbsp;/&nbsp;{{event.max_attendees}}</p>
					<v-list>
						<v-list-tile avatar v-for="attendee in event.attendees.slice(0,20)" :key="attendee.uuid" @click="openGuestModal(attendee.uuid)">
							<v-list-tile-avatar>
								<img :src="attendee.avatar">
							</v-list-tile-avatar>
							<v-list-tile-content style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
								<v-list-tile-title v-text="attendee.first_name + ' ' + attendee.last_name"></v-list-tile-title>
								<v-tooltip top v-if="userInAddon(attendee.pk)">
									<v-icon small slot="activator" class="ma-0 pa-0">fal fa-star</v-icon>
									<span>Attending {{event.addons[0].title}}</span>
								</v-tooltip>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
					<div v-if="event.denied_attendees.length > 0">
						<h4 class="text-xs-center error--text">Denied Attendees</h4>
						<v-list>
							<v-list-tile avatar v-for="attendee in event.denied_attendees" :key="attendee.uuid" @click="openGuestModal(attendee.uuid)">
								<v-list-tile-avatar>
									<img :src="attendee.avatar">
								</v-list-tile-avatar>
								<v-list-tile-content style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
									<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline">
										<v-tooltip top>
											<v-btn icon slot="activator" @click.stop="approveGuest(attendee.uuid)" class="ma-0">
												<v-icon color="success">fal fa-plus-circle</v-icon>
											</v-btn>
											<span>Switch to Approved</span>
										</v-tooltip>
									</div>
									<v-list-tile-title v-text="attendee.first_name + ' ' + attendee.last_name"></v-list-tile-title>
									<v-tooltip top v-if="userInAddon(attendee.pk)">
										<v-icon small slot="activator" class="ma-0">fal fa-star</v-icon>
										<span>Attending {{event.addons[0].title}}</span>
									</v-tooltip>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
					</div>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
			<v-card-actions>
				<v-btn @click="messageAllGuestsModal=true">Message all guests</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
export default {
	name: 'eventAttendeesModal',
	methods: {
		...mapActions([
			'setModalOpen',
			'setModalProp',
			'setEventProp'
		]),
		openGuestModal(index) {
			this.guestModal = true
			this.guestModalIndex = index
		},
		userInAddon(pk) {
			if (this.event.addons.length > 0) {
				if (this.event.addons[0].attendees) {
					if (this.event.addons[0].attendees.includes(pk)) {
						return true
					}
				}
			}
			return false
		},
		approveGuest(guestUUID) {
			axios
				.get(
					'/api/v1/event/' +
						this.event.slug +
						'/approve-guest/' +
						guestUUID +
						'/'
				)
				.then(response => {
					console.log(response)
					let userObj = this.event.pending_attendees.find(
						obj => obj.uuid === guestUUID
					)
					let newArray = this.event.pending_attendees.slice(0)
					newArray.splice(this.event.pending_attendees.indexOf(userObj), 1)
					this.setEventProp({
						uuid: this.event.uuid,
						prop: 'pending_attendees',
						value: newArray
					})
					this.setEventProp({
						uuid: this.event.uuid,
						prop: 'attendees',
						value: this.event.attendees.concat(userObj)
					})
				})
				.catch(error => {
					console.error(error)
				})
		},
		denyGuest(guestUUID) {
			this.guestModalIndex = guestUUID
			this.setModalOpen({ prop: 'denyGuestConfirmationModal', value: true })
			// axios.get('/api/v1/event/' + this.event.slug + '/deny-guest/' + guestUUID + '/')
			// 	.then((response) => {
			// 		console.log(response)
			// 		let userObj = this.event.pending_attendees.find((obj) => obj.uuid === guestUUID)
			// 		this.setEventProp({
			// 			uuid: this.event.uuid,
			// 			prop: 'pending_attendees',
			// 			value: this.event.pending_attendees.slice(this.event.pending_attendees.indexOf(userObj), 1)
			// 		})
			// 		this.setEventProp({
			// 			uuid: this.event.uuid,
			// 			prop: 'denied_attendees',
			// 			value: this.event.denied_attendees.concat(userObj)
			// 		})
			// 	})
			// 	.catch((error) => {
			// 		console.error(error)
			// 	})
		}
	},
	computed: {
		...mapGetters(['getModalProp', 'getAllEvents']),
		open: {
			get() {
				return this.getModalProp('eventAttendeesModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventAttendeesModal', value: val })
			}
		},
		guestModal: {
			get() {
				return this.getModalProp('eventGuestModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventGuestModal', value: val })
			}
		},
		messageAllGuestsModal: {
			get() {
				return this.getModalProp('eventContactAllGuestsModal')
			},
			set (val) {
				this.setModalOpen({ prop: 'eventContactAllGuestsModal', value: val })
			}
		},
		guestModalIndex: {
			get() {
				return this.getModalProp('eventGuestModalIndex')
			},
			set(val) {
				this.setModalProp({ prop: 'eventGuestModalIndex', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
